import { useCallback, useEffect } from 'react';

import { useGetDetailsQuery } from 'store/user/userAPI';
import { useLazyGetCandidateSummaryQuery } from 'store/my-registrations/myRegistrationsAPI';

export const useMyRegistrationsData = () => {
  const { data: user, isFetching: userIsLoading } = useGetDetailsQuery();
  const [getCandidateSummary, { data, isFetching: summaryIsLoading }] = useLazyGetCandidateSummaryQuery();

  const refreshCandidateSummary = useCallback(() => {
    if (user) {
      getCandidateSummary(user.email);
    }
  }, [user, getCandidateSummary]);

  useEffect(() => {
    if (user) {
      getCandidateSummary(user.email);
    }
  }, [getCandidateSummary, user]);

  return {
    isLoading: userIsLoading || summaryIsLoading,
    user,
    data,
    refreshCandidateSummary,
  };
};
